import { useMemo } from 'react';
import { PermissionListItem } from 'src/components/permissions/list/types';
import { PermissionListFilterInput } from 'src/graphql/generated/graphql';

type Props = {
  permissions: PermissionListItem[];
  filter: PermissionListFilterInput;
};

export const useFilteredPermissions = ({ permissions, filter }: Props) => {
  return useMemo(() => {
    return permissions.filter((permission) => {
      if (
        filter?.search &&
        !(
          permission.name.toLowerCase().includes(filter.search.toLowerCase()) ||
          permission.description
            ?.toLowerCase()
            .includes(filter.search.toLowerCase())
        )
      ) {
        return false;
      }

      if (filter?.subject && permission.subject !== filter.subject) {
        return false;
      }

      if (filter?.action && permission.action !== filter.action) {
        return false;
      }

      if (filter?.appArea && permission.appArea !== filter.appArea) {
        return false;
      }

      return true;
    });
  }, [permissions, filter]);
};
